import {useState} from 'react';

function Loginbonus() {

    const test = () => {
        var days = localStorage.getItem("consecutiveDays");
        console.log(days);
        // if days exist, increment by one
        if (days === null)
        {
            console.log("days were null");
            days = 1;
        }
        //else set to one
        else
        {
            console.log("days not null" + days);
            days++;
            if(days > 7) days = 0;
        }
        
        localStorage.setItem("consecutiveDays", days)

        var brass = localStorage.getItem("Brass");
        if (brass === null)
        {
            brass = 100;
        }
        //else set to one
        else
        {
            brass++;
        }
        localStorage.setItem("Brass", brass);
    }
    const [incantationRead, setIncantationRead] = useState(false);
    const [termsChecked, setTermsChecked] = useState(false);

    return (
    <>
        <div className="card" >
            <div className="card-header">Daily Login Bonus</div>
            <div className="card-body">
                <p className="card-text">Volo videre tenebras aeternas
                                    Ego certe amo tenebras
                                    Vere fan tenebrarum
                        Me et tenebrae sunt sicut amici optimi
                        Ita vere gratum essem si habere possem infinitas tenebras
                        Hoc vere sit multum
                        Gratias tibi valde</p>
            </div>
        </div>

        <div>
          <input
            type="checkbox"
            checked={incantationRead}
            onChange={(e) => setIncantationRead(e.target.checked)}
          />{" "}
          I have read the incantation above*
        </div>
        <div>
          <input
            type="checkbox"
            checked={termsChecked}
            onChange={(e) => setTermsChecked(e.target.checked)}
          />
          I agree to be one step closer to dark mode!
        </div>

        <button className="Submit" onClick={test} disabled={!incantationRead || !termsChecked}>
                    <h3>Submit</h3>
        </button>
    </>
    )
}

export default Loginbonus;